import { useCallback } from 'react';

import useAppFeatures from './useAppFeatures';
import useRoleFeatures from './useRoleFeatures';

const allowedFlags: string[] = ['showLasagnaPage'];
function isFeatureStoredInLocalStorageAllowed(feature) {
  if (allowedFlags.includes(feature)) {
    return !!window.localStorage.getItem(`feature_${feature}`);
  }
  return false;
}

function useIsFeatureEnabled() {
  const appFeatures = useAppFeatures();
  const roleFeatures = useRoleFeatures();

  return useCallback(
    feature => {
      if (isFeatureStoredInLocalStorageAllowed(feature)) {
        return true;
      }

      return !!appFeatures[feature] || !!roleFeatures[feature];
    },
    [appFeatures, roleFeatures]
  );
}
export default useIsFeatureEnabled;
